import moment from 'moment';
import type {
  ChildAttendeeWithInfosType,
  AdultAttendeeWithInfosType,
} from 'Store/booking/booking.selector';
import 'Store/booking/booking.selector';
export const ATTENDEE_CATEGORIES = {
  BABY: 'BABY',
  CHILD: 'CHILD',
  ADULT: 'ADULT',
};
export const getAttendeeCategory = (
  attendee: ProposalAttendeesType | AdultAttendeeWithInfosType | ChildAttendeeWithInfosType,
  arrivalDate: string,
): string => {
  if (attendee.birthdate && moment(arrivalDate).diff(moment(attendee.birthdate), 'months') < 24) {
    return ATTENDEE_CATEGORIES.BABY;
  }

  if (
    attendee.birthdate &&
    moment(arrivalDate).diff(moment(attendee.birthdate), 'months') >= 24 &&
    moment(arrivalDate).diff(moment(attendee.birthdate), 'years') < 18
  ) {
    return ATTENDEE_CATEGORIES.CHILD;
  }

  return ATTENDEE_CATEGORIES.ADULT;
};
export type DistributionAttendeesByCategory = {
  adults: Array<ArrangementAttendee>;
  children: Array<ArrangementAttendee>;
  babies: Array<ArrangementAttendee>;
};
export const getAttendeesByDistributionCategory = (
  attendees: ReadonlyArray<ArrangementAttendee>,
): DistributionAttendeesByCategory => {
  const sortAttendeesByIndex = (attendee1, attendee2) => attendee1.index - attendee2.index;

  return {
    adults: attendees
      .filter(({ type }) => type.toUpperCase() === ATTENDEE_CATEGORIES.ADULT)
      .sort(sortAttendeesByIndex),
    children: attendees
      .filter(({ type }) => type.toUpperCase() === ATTENDEE_CATEGORIES.CHILD)
      .sort(sortAttendeesByIndex),
    babies: attendees
      .filter(({ type }) => type.toUpperCase() === ATTENDEE_CATEGORIES.BABY)
      .sort(sortAttendeesByIndex),
  };
};
export const addDistributionDataToAttendees = (
  attendees: ReadonlyArray<AdultAttendeeWithInfosType | ChildAttendeeWithInfosType>,
  arrivalDate: string,
): Array<ArrangementAttendee> => {
  const distributionIndex = {
    ADULT: 0,
    CHILD: 0,
    BABY: 0,
  };
  return attendees.map((attendee) => {
    const type = getAttendeeCategory(attendee, arrivalDate);
    return { ...attendee, type, index: distributionIndex[type]++ };
  }) as ArrangementAttendee[];
};
